import type { EngineThemeStatus, EngineThemeUpdateResult } from '../../lib/api';

export type EngineUpdateOutcome = {
  state: 'queued' | 'running' | 'success' | 'error' | 'skipped' | 'unverified';
  message: string;
};
export type EngineUpdateTarget = { id: string; integrationId?: string | null; current: boolean };
export async function runEngineUpdateQueue(targets: EngineUpdateTarget[], deps: {
  isActive: () => boolean;
  update: (id: string) => Promise<EngineThemeUpdateResult>;
  verify: (id: string) => Promise<EngineThemeStatus>;
  report: (id: string, outcome: EngineUpdateOutcome) => void;
}) {
  for (const target of targets) {
    if (!deps.isActive()) break;
    if (!target.integrationId || target.current) {
      deps.report(target.id, { state: 'skipped', message: target.current ? 'Engine jest aktualny.' : 'Pominięto: Engine nie jest włączony dla tego sklepu.' });
      continue;
    }
    deps.report(target.id, { state: 'running', message: 'Aktualizowanie...' });
    try {
      const data = await deps.update(target.integrationId);
      const status = await deps.verify(target.integrationId)
        .catch((): EngineThemeStatus => ({ status: 'unknown', latestVersion: '', message: 'Brak połączenia podczas weryfikacji.' }));
      deps.report(target.id, status.status === 'current'
        ? { state: 'success', message: `Engine ${status.currentVersion}: aktualny.` }
        : { state: 'unverified', message: `WordPress potwierdził aktualizację${data.currentVersion ? ` do ${data.currentVersion}` : ''}, ale nie udało się potwierdzić najnowszej wersji. ${status.message ?? 'Sprawdź status ponownie.'}` });
    } catch (error) {
      const response = error as { response?: { data?: { error?: string; message?: string } } };
      const message = response.response?.data?.error ?? response.response?.data?.message;
      deps.report(target.id, { state: 'error', message: typeof message === 'string' ? message : 'Nie otrzymano potwierdzenia aktualizacji. Sprawdź stan sklepu przed ponowieniem.' });
    }
  }
}
